import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

export default function BalanceDetails() {
  const [BalanceList, setBalanceList] = useState([]);

  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  useEffect(() => {
    fetchBalanceDeatails();
  }, []);

  const fetchBalanceDeatails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/dashboard/FetchBalanceDetails`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      setBalanceList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="DetailsHead">
        <p className="DetailsP">Customer Name</p>
        <p className="DetailsP">Contact Number</p>
        <p className="DetailsP">Balance (₹)</p>
      </div>
      {BalanceList.length <= 0 ? (
        <p>No Balance Found</p>
      ) : (
        BalanceList.map((item, index) => {
          return (
            <div key={index} className="Detailsbody">
              <p className="DetailsP">{item.Customer_Name}</p>
              <p className="DetailsP">{item.Contact1}</p>
              <p className="DetailsP">{item.Balance}</p>
            </div>
          );
        })
      )}
    </>
  );
}
